export * from './no-dbl-click.directive';
export * from './no-dbl-click.module';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/no-dbl-click/index.ts